import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ShoppingCart} from "@biletix/core/models/shopping-cart/shopping-cart.model";
import {Observable} from "rxjs";
import {TicketSaleService} from "@biletix/core/services/ticket-sale.service";
import {TranslateService} from "@ngx-translate/core";
import {map} from "rxjs/operators";
import {environment} from "@biletix/env";
import {RegionService} from "@biletix/core/services/region.service";
import {Router} from "@angular/router";
import {I18nService} from "@biletix/core/services/i18n.service";
import { RouterService } from "@biletix/core/services/router.service";
import {DeliveryChoice} from "@biletix/core/models/delivery/choice/delivery-choice.model";
import {EventProfileType} from "@biletix/core/common/enums/event-profile-type.enum";
import { AbstractionComponent } from '@biletix/core/common/abstraction-component';
import { ApplicationStateService } from '@biletix/core/services/application-state.service';
import {PerformancePageStateService} from "@biletix/features/performance/services/performance-page-state.service";


@Component({
    selector: 'btx-checkout-summary',
    templateUrl: './checkout-summary.component.html',
    styleUrls: ['./checkout-summary.component.scss'],
  standalone: false
})
export class CheckoutSummaryComponent extends AbstractionComponent implements OnInit {
   @Input() isShowButton: boolean = true;

    @Input("buttonLabel") buttonLabel?: string;
    @Output("clicked") clicked = new EventEmitter<void>();

    shoppingCart$: Observable<ShoppingCart>;

    upsellTotalPrice$: Observable<number>;

    shoppingItemsTotalPrice$: Observable<number>;

    showBackToEventPackageDetailBtn = false;

    isBuyFast:boolean = false;

    constructor(private ticketSaleService: TicketSaleService,
                private translate: TranslateService,
                private  region: RegionService,
                private router: Router,
                private i18n: I18nService,
                private performancePageStateService:PerformancePageStateService,
                private ApplicationStateService: ApplicationStateService,
                public routerService: RouterService) {
        super();

        //watch shopping cart
        this.shoppingCart$ = this.ticketSaleService.watchShoppingCart;

        this.shoppingCart$.pipe(this.takeUntilDestroy()).subscribe(cart=>{
          if(cart.btxEventPackageId != null){
            this.showBackToEventPackageDetailBtn = true;
          }

          this.isBuyFast = cart.shoppingItems.some(item => item.buyFast)
        });

        //get shoping upsell total price
        this.upsellTotalPrice$=this.shoppingCart$
            .pipe(map(cart=>this.calculateTotalPrice(cart?.shoppingUpsellItems, 'upsellTotalPrice')));


        //get shoping items total price
        this.shoppingItemsTotalPrice$=this.shoppingCart$
            .pipe(map(cart=>this.calculateTotalPrice(cart?.shoppingItems, 'totalPrice')));

    }

    ngOnInit(): void {
        this.initialVariables();
    }

    initialVariables() {
        if (!this.buttonLabel) {
            this.buttonLabel = this.translate.instant('shared.labels.continue');
        }



    }

    private calculateTotalPrice(stateItems: any[], prop: string): number {
        return stateItems?.reduce((prev, cur) => prev + cur[prop], 0) ?? 0;
    }

    public handleMissingImage(event: Event) {
        (event.target as HTMLImageElement).style.display = 'none';
      }

    onClicked() {
        this.clicked.emit();
    }

    getDeliveryChoice(shoppingCart: ShoppingCart): DeliveryChoice | null {

      return shoppingCart && shoppingCart.deliveryChoice && shoppingCart.deliveryChoice.amount > 0 ? shoppingCart.deliveryChoice: null;

    }

    getSeamHomePageUrl() {
      return `${environment.biletixWebHost}/anasayfa/${this.regionLanguagePath}`;
    }

    getCampaignUrl() {
        return `https://guides.biletix.com/black-friday-22/${this.regionLanguagePath}`;
    }

    getCampaignImageUrl() {
        return `${environment.biletixWebHost}/static/images/design2015/blackfriday-275x142.png`;
    }

    getEventPackageDetailPageUrl(eventPackageId: number): string {
      return `/etkinlik-paket-detay/${eventPackageId}/${this.regionLanguagePath}`;
    }

    navigateToEventPackageDetailPage(eventPackageId: number) {
      this.router.navigate(
          [this.getEventPackageDetailPageUrl(eventPackageId)]
      )
  }

    /* public get homePageUrl(): string {
      return `/home/${this.regionLanguagePath}`;

   }

    navigateToHomePage() {
      this.router.navigate([this.homePageUrl]);
    } */

    public get regionLanguagePath() {
      return `${this.region.regionName}/${this.i18n.currentLang}`;
    }

    getIsMobile() {
      return this.ApplicationStateService.getIsMobileResolution();
    }

}
